import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '../basic-inputs';

export function NoPersonWarning() {
  const navigate = useNavigate();

  const handleFillOutProfile = useCallback(() => {
    navigate('/profiles/new');
  }, [ navigate ]);

  return (
    <div className="no-person-warning">
      <div className="warning-content">
        <h2>Profile Required</h2>
        <p>
          You must fill out your profile before proceeding to this page. 
          Please complete your personal information to continue.
        </p>
        <Button 
          onClick={handleFillOutProfile}
          fullWidth
        >
          Fill Out Profile!
        </Button>
      </div>
    </div>
  );
}
